import React from "react";

interface IOverviewCardHeader {
  icon: React.ReactElement;
  title: string;
  displayValue: string | number;
}

const OverviewCardHeader: React.FC<IOverviewCardHeader> = ({
  icon,
  title,
  displayValue,
}) => {
  return (
    <header className="d-flex amd-container-vcolumn mt-sm-2 pb-sm-2">
      <div className="d-flex">
        <div className="fs-40 pr-sm-1">{displayValue}</div>
        <div
          className={`d-flex amd-container-vcolumn`}
          style={{ marginTop: "-3px" }}
        >
          {icon}
          <div className="fs-14 fw-500">{title}</div>
        </div>
      </div>
    </header>
  );
};

export default OverviewCardHeader;
